<!-- 
	AdminUserDate
	props: User
  	role: Admin
	Called by @/views/AdminUser to display an individual user's page to an admin
-->

<template>
	<div class="admin-user-data">
		<div v-if="user.adminData !== null">
			<div v-if="index !== undefined">
				<div
					class="
            greeting
            flex
            items-stretch
            flex-col
            sm:flex-row
            justify-between
            text-center
            sm:text-left
            pb-4
          "
				>
					<div
						class="text-3xl sm:mr-4 my-auto py-6 sm:p-4 w-full sm:w-1/3 flex-1"
					>
						<div>
							Viewing
							<span class="capitalize">{{ userData.FirstName }}'s Profile</span>
						</div>
					</div>
					<div
						class="
              text-3xl
              sm:mr-4
              py-6
              sm:p-4
			  mb-4
			  sm:mb-0
              w-full
              sm:w-1/3
              flex-1
              text-center
              bg-purple
            "
					>
						<div
							v-if="
								userData.Year2026 && !userData.OptOutMain && !userData.OptOut5050
							"
						>
							<div class="pb-2">
								<span class="capitalize">{{ userData.FirstName }}</span> is
								currently
							</div>
							<div class="uppercase underline">Enrolled</div>
						</div>
						<div v-else>
							<div class="pb-2">{{ userData.FirstName }} is currently</div>
							<div class="uppercase underline">not Enrolled</div>
						</div>
					</div>
					<div class="py-6 sm:p-4 w-full sm:w-1/3 flex-1 bg-purple">
						<div class="font-bold">Current Ticket Packages:</div>
						<div>WinWin Main Lottery: {{ getCurrentMainTicketPackage() }}</div>
						<div>Quarterly Cash 50/50: {{ getCurrent5050TicketPackage() }}</div>
						<!--
						<div
							v-if="
								userData.CurrentMainTicketPackage == 40 ||
									userData.NewMainTicketPackage == 40
							"
						>
							<div>Set of 40 Tickets for $40 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.CurrentMainTicketPackage == 30 ||
									userData.NewMainTicketPackage == 30
							"
						>
							<div>Set of 15 Tickets for $30 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.CurrentMainTicketPackage == 20 ||
									userData.NewMainTicketPackage == 20
							"
						>
							<div>Set of 8 Tickets for $20 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.CurrentMainTicketPackage == 10 ||
									userData.NewMainTicketPackage == 10
							"
						>
							<div>Set of 3 Tickets for $10 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.CurrentMainTicketPackage == 5 ||
									userData.NewMainTicketPackage == 5
							"
						>
							<div>Single Tickets for $5 (deducted per pay period)</div>
						</div>
						<div
							v-else-if="
								userData.CurrentMainTicketPackage == null &&
									userData.NewMainTicketPackage == null
							"
						>
							No Main Ticket Package Entered
						</div>
						<div
							v-if="
								userData.Current5050TicketPackage == 35 ||
									userData.New5050TicketPackage == 35
							"
						>
							<div>Sets of 35 Tickets for $35 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.Current5050TicketPackage == 25 ||
									userData.New5050TicketPackage == 25
							"
						>
							<div>Sets of 16 Tickets for $25 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.Current5050TicketPackage == 10 ||
									userData.New5050TicketPackage == 10
							"
						>
							<div>Sets of 4 Tickets for $10 (deducted per pay period)</div>
						</div>
						<div
							v-if="
								userData.Current5050TicketPackage == 5 ||
									userData.New5050TicketPackage == 5
							"
						>
							<div>Single Ticket for $5 (deducted per pay period)</div>
						</div>
						<div
							v-else-if="
								userData.Current5050TicketPackage == null &&
									userData.New5050TicketPackage == null
							"
						>
							No 50/50 Ticket Package Entered
						</div>
					-->
						<div>Lottery Proceeds Benefitting:</div>
						<div
							v-if="userData.NewDesignation || userData.CurrentDesignation"
						>
							{{ userData.NewDesignation || userData.CurrentDesignation }}
						</div>
						<div v-else>Not Yet Selected</div>
					</div>
				</div>
				<div class="user-info flex flex-col sm:flex-row justify-between pb-4">
					<div
						class="
              bg-white
              text-black
              py-6
              sm:mr-4
              sm:p-4
			  mb-4
			  sm:mb-0
              w-full
              sm:w-1/3
              text-center
              sm:text-left
            "
					>
						<div class="font-bold">Your Information</div>
						<div class="capitalize">
							<span>Name: </span>
							<span>{{ userData.FirstName }} {{ userData.LastName }}</span>
						</div>
						<div class="">
							<span>Employee ID: </span>
							<span>{{ userData.EmployeeId }}</span>
						</div>
						<div class="">
							<span>Company: </span>
							<span v-if="userData.PayrollSelection === 'CHR'">
								Alberta Health Services
							</span>
							<span v-if="userData.PayrollSelection === 'CW'">
								Carewest
							</span>
							<span v-if="userData.PayrollSelection === 'COV'">
								Covenant Health
							</span>
							<span v-if="userData.PayrollSelection === 'LAB'">
								Alberta Precision Labs
							</span>
						</div>
						<div class="">
							<span>Email: </span>
							<span>{{ userData.EmailAddress }}</span>
						</div>
						<div v-if="user.data.emailVerified !== true" class="">
							<span>Your Email has not been verified.</span>
						</div>
					</div>
					<div
						class="
              bg-white
              text-black
              py-6
              sm:mr-4
              sm:p-4
			  mb-4
			  sm:mb-0
              w-full
              sm:w-1/3
              text-center
              sm:text-left
            "
					>
						<div class="font-bold">Contact Information</div>
						<div v-if="userData.HomePhone !== null">
							<span>Home Phone: </span>
							<span
								>({{ userData.HomePhone.slice(0, 3) }})
								{{ userData.HomePhone.slice(3, 6) }}-{{
									userData.HomePhone.slice(6, 10)
								}}
							</span>
						</div>
						<div v-if="userData.MobilePhone !== null">
							<span>Mobile Phone: </span>
							<span
								>({{ userData.MobilePhone.slice(0, 3) }})
								{{ userData.MobilePhone.slice(3, 6) }}-{{
									userData.MobilePhone.slice(6, 10)
								}}
							</span>
						</div>
						<div class="">
							<span>Street Address: </span>
							<span>{{ userData.AddressLineOne }}</span>
						</div>
						<div class="">
							<span>City/Province: </span>
							<span class="capitalize"
								>{{ userData.City }}, {{ userData.Province }}</span
							>
						</div>
						<div class="">
							<span>Postal Code: </span>
							<span class="uppercase">{{ userData.PostalCode }}</span>
						</div>
					</div>
					<div
						class="
              bg-white
              text-black
              py-6
			  mb-4
			  sm:mb-0
              sm:p-4
              w-full
              sm:w-1/3
              text-center
              sm:text-left
            "
					>
						<div class="font-bold">Participation History</div>
						<div class="">
							<span>WinWin 2026: </span>
							<span v-if="userData.Year2026 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2025: </span>
							<span v-if="userData.Year2025 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2024: </span>
							<span v-if="userData.Year2024 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2023: </span>
							<span v-if="userData.Year2023 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2022: </span>
							<span v-if="userData.Year2022 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2021: </span>
							<span v-if="userData.Year2021 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2020: </span>
							<span v-if="userData.Year2020 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2019: </span>
							<span v-if="userData.Year2019 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2018: </span>
							<span v-if="userData.Year2018 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
						<div class="">
							<span>WinWin 2017: </span>
							<span v-if="userData.Year2017 === true">Enrolled</span>
							<span v-else>Did Not Participate</span>
						</div>
					</div>
				</div>

				<!--
				<div
					v-if="
						this.pay !== null && this.loading === false && this.pay.length > 0
					"
					class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
				>
					<div class="font-bold">Deduction History</div>
					<div
						v-for="period in pay"
						v-bind:key="period.Id"
						class="block text-center sm:inline-block sm:w-2/4 my-1.5"
					>
						<div class="font-bold">{{ dateTime(period.PayPeriodDate) }}</div>
						<div>
							<div v-if="period.DeductionMain !== ''">
								${{ period.DeductionMain }}
							</div>
							<div v-if="period.Deduction5050 !== ''">
								${{ period.Deduction5050 }}
							</div>
							<div v-else>No Deduction Yet!</div>
						</div>
					</div>
				</div>
				<div
					v-else-if="this.loading === false && this.pay.length === 0"
					class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
				>
					No Pay Period Deduction Data to Display
				</div>
				<div
					v-else
					class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
				>
					<Loading />
				</div>
				-->
				<div
					
					class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
				>
					

					<div
      class="timeline"
    >
      <h1
        class="text-4xl"
        style="color: #1a1f56;"
      >
        DEDUCTION TIMELINE
      </h1>

      

      <div
        v-for="i in indexArr"
      >
	  	


		<div
            class="timeline__event  animated fadeInUp"
          >
            <div class="timeline__event__icon ">
              <i class="icon">2026</i>
              <div class="timeline__event__date">
                {{ moment(DEDUCTIONSCHEDULE[i]).format("MMM DD") }}
              </div>
            </div>
            <div class="timeline__event__content ">
              <div class="table-wrapper">
                <div class="d-flex flex-column">
                  <div class="timeline__event__title">
                    DEDUCTIONS
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="font-size: 11px;color:#6b7280;"
                  >
                    
                    
                    <template v-if="deductionFlagArr[i]">
                      <div class="d-flex flex-row">
                        <p class="flex-grow-1 mr-2 text-left">
                          WinWin Staff Lottery
                        </p>
                        <p v-if="deductionMainArr[i]" class="justify-end flex-grow-1 text-right">
                          ${{ deductionMainArr[i] }}
                        </p>
                        <p v-else class="justify-end flex-grow-1 text-right">
                          $0
                        </p>
                      </div>
                      <div class="d-flex flex-row">
                        <p class="flex-grow-1 mr-2 text-left">
                          Quarterly Cash 50|50
                        </p>
                        <p v-if="deduction50Arr[i]" class="justify-end flex-grow-1 text-right">
                          ${{ deduction50Arr[i] }}
                        </p>
                        <p v-else class="justify-end flex-grow-1 text-right">
                          $0
                        </p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="timeline__event__description text-left">
                        <p>NO DEDUCTION</p>
                      </div>
                    </template>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>


		
      </div>
    				</div>
					
				</div>

			</div>
			<div v-else>
				{{ error }}
			</div>
		</div>
		<div v-else><Loading />></div>
	</div>
</template>
<script>
	import { useRoute } from "vue-router";
	import moment from "moment";

	import Loading from "@/components/Loading";

	import { getUserPayPeriod } from "@/utils/api";

	import { DEDUCTIONSCHEDULE, WINWINMAINPACKAGES, WINWIN5050PACKAGES, nextDrawDate}  from '@/utils/constants'

	export default {
		name: "AdminUserData",
		components: {
			Loading,
		},
		props: ["user"],
		data() {
			return {
				pay: null,
				loading: true,
				optOuts: [],
				//delay: 3,
                DEDUCTIONSCHEDULE
			};
		},
		setup(props) {
			// get the user page based off UserId passed by params from admin user list
			const route = useRoute();
			const userId = route.params.User_Id;

			const query = props.user.adminData;

			const userProfile = query.find((o) => o.UserId === userId);
			const index = query.indexOf(userProfile);

			const userData = props.user.adminData[index].Profile;

			if (index !== -1) {
				return { index, userData };
			} else {
				const error = "Unable to locate User Profile";

				return { error };
			}
		},

		async created() {
			// get user pay period and opt out requests
			const route = useRoute();
			const userId = route.params.User_Id;

			const token = this.$props.user.token;

			const payPeriods = await getUserPayPeriod(token, userId);

			this.pay = payPeriods.Data;
			this.loading = false;
		},

		computed:{
          indexArr(){
            const arr = new Array(26);
            for (let i=0; i<arr.length; i++){
              arr[i] = i;
            }
            return arr;
          },
          deductionMainArr(){
            const arr = new Array(26);

			arr[0] = this.userData.f_PP01TempDeductionMain;
            arr[1] = this.userData.f_PP02TempDeductionMain;
            arr[2] = this.userData.f_PP03TempDeductionMain;
            arr[3] = this.userData.f_PP04TempDeductionMain;


			/**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
			// arr[0] = this.userData.f_PP01DeductionMain;
			// arr[1] = this.userData.f_PP02DeductionMain;
			// arr[2] = this.userData.f_PP03DeductionMain;
			// arr[3] = this.userData.f_PP04DeductionMain;
            // arr[4] = this.userData.f_PP05DeductionMain;
            // arr[5] = this.userData.f_PP06DeductionMain;
            // arr[6] = this.userData.f_PP07DeductionMain;
            // arr[7] = this.userData.f_PP08DeductionMain;
            // arr[8] = this.userData.f_PP09DeductionMain;
            // arr[9] = this.userData.f_PP10DeductionMain;
            // arr[10] = this.userData.f_PP11DeductionMain;
            // arr[11] = this.userData.f_PP12DeductionMain;
            // arr[12] = this.userData.f_PP13DeductionMain;
            // arr[13] = this.userData.f_PP14DeductionMain;
            // arr[14] = this.userData.f_PP15DeductionMain;
            // arr[15] = this.userData.f_PP16DeductionMain;
            // arr[16] = this.userData.f_PP17DeductionMain;
            // arr[17] = this.userData.f_PP18DeductionMain;
            // arr[18] = this.userData.f_PP19DeductionMain;
            // arr[19] = this.userData.f_PP20DeductionMain;
            // arr[20] = this.userData.f_PP21DeductionMain;
            // arr[21] = this.userData.f_PP22DeductionMain;
            // arr[22] = this.userData.f_PP23DeductionMain;
            // arr[23] = this.userData.f_PP24DeductionMain;
            // arr[24] = this.userData.f_PP25DeductionMain;
            // arr[25] = this.userData.f_PP26DeductionMain;

            return arr;
          },
          deduction50Arr(){
            const arr = new Array(26);
            
            arr[0] = this.userData.f_PP01TempDeduction50;
            arr[1] = this.userData.f_PP02TempDeduction50;
            arr[2] = this.userData.f_PP03TempDeduction50;
            arr[3] = this.userData.f_PP04TempDeduction50;

			/**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
			// arr[0] = this.userData.f_PP01Deduction50;
			// arr[1] = this.userData.f_PP02Deduction50;
			// arr[2] = this.userData.f_PP03Deduction50;
			// arr[3] = this.userData.f_PP04Deduction50;
            // arr[4] = this.userData.f_PP05Deduction50;
            // arr[5] = this.userData.f_PP06Deduction50;
            // arr[6] = this.userData.f_PP07Deduction50;
            // arr[7] = this.userData.f_PP08Deduction50;
            // arr[8] = this.userData.f_PP09Deduction50;
            // arr[9] = this.userData.f_PP10Deduction50;
            // arr[10] = this.userData.f_PP11Deduction50;
            // arr[11] = this.userData.f_PP12Deduction50;
            // arr[12] = this.userData.f_PP13Deduction50;
            // arr[13] = this.userData.f_PP14Deduction50;
            // arr[14] = this.userData.f_PP15Deduction50;
            // arr[15] = this.userData.f_PP16Deduction50;
            // arr[16] = this.userData.f_PP17Deduction50;
            // arr[17] = this.userData.f_PP18Deduction50;
            // arr[18] = this.userData.f_PP19Deduction50;
            // arr[19] = this.userData.f_PP20Deduction50;
            // arr[20] = this.userData.f_PP21Deduction50;
            // arr[21] = this.userData.f_PP22Deduction50;
            // arr[22] = this.userData.f_PP23Deduction50;
            // arr[23] = this.userData.f_PP24Deduction50;
            // arr[24] = this.userData.f_PP25Deduction50;
            // arr[25] = this.userData.f_PP26Deduction50;

            return arr;
          },
          deductionFlagArr(){
            const arr = new Array(26);
            
            arr[0] = this.userData.f_PP01Temp;
            arr[1] = this.userData.f_PP02Temp;
            arr[2] = this.userData.f_PP03Temp;
            arr[3] = this.userData.f_PP04Temp;

			/**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
            // arr[0] = this.userData.f_PP01;
            // arr[1] = this.userData.f_PP02;
            // arr[2] = this.userData.f_PP03;
            // arr[3] = this.userData.f_PP04;
            // arr[4] = this.userData.f_PP05;
            // arr[5] = this.userData.f_PP06;
            // arr[6] = this.userData.f_PP07;
            // arr[7] = this.userData.f_PP08;
            // arr[8] = this.userData.f_PP09;
            // arr[9] = this.userData.f_PP10;
            // arr[10] = this.userData.f_PP11;
			// arr[11] = this.userData.f_PP12;
            // arr[12] = this.userData.f_PP13;
            // arr[13] = this.userData.f_PP14;
            // arr[14] = this.userData.f_PP15;
            // arr[15] = this.userData.f_PP16;
            // arr[16] = this.userData.f_PP17;
            // arr[17] = this.userData.f_PP18;
            // arr[18] = this.userData.f_PP19;
            // arr[19] = this.userData.f_PP20;
            // arr[20] = this.userData.f_PP21;
            // arr[21] = this.userData.f_PP22;
            // arr[22] = this.userData.f_PP23;
            // arr[23] = this.userData.f_PP24;
            // arr[24] = this.userData.f_PP25;
            // arr[25] = this.userData.f_PP26;

            return arr;
          },
        },

		methods: {
			dateTime(value) {
				// format Date object to readible format
				return moment(value).format("MMMM Do, YYYY");
			},
			moment: function (date) {
                return moment(date);
            },
			getCurrentMainTicketPackage() {
				var currentMain = this.userData.CurrentMainTicketPackage ?? null;
				var newMain = this.userData.NewMainTicketPackage ?? null;

				var main = newMain || currentMain;
				if (main && !isNaN(main)) {
					var ticketPackage = WINWINMAINPACKAGES.find(x=>x.Cost == main)
					if (ticketPackage) return ticketPackage.Name
				}
				return "No Main Ticket Package Entered"
			},
			getCurrent5050TicketPackage() {
				var current5050 = this.userData.Current5050TicketPackage ?? null;
				
				var new5050 = this.userData.New5050TicketPackage ?? null;

				
				var fiftyFifty = new5050 || current5050

				if (fiftyFifty && !isNaN(fiftyFifty)) {
					var ticketPackage = WINWIN5050PACKAGES.find(x=>x.Cost == fiftyFifty)
					if (ticketPackage) return ticketPackage.Name
				}
				return "No 50/50 Ticket Package Entered"
			},
		},
	};
</script>
<style scoped>
	.bg-purple {
		background-color: #1a1f56;
	}

	.timeline {
		  display: flex;
		  flex-direction: column;
		  max-width: 50%;
		  margin: 5% auto;
		}
		.timeline__event {
		  background: #fff;
		  margin-bottom: 20px;
		  position: relative;
		  display: flex;
		  margin: 20px 0;
		  border-radius: 8px;
		  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25), 0 18px 36px -18px rgba(0, 0, 0, 0.3), 0 -12px 36px -8px rgba(0, 0, 0, 0.025);
		}
		.timeline__event__title {
		  font-size: 1rem;
		  line-height: 1.4;
		  text-transform: uppercase;
		  font-weight: 600;
		  color: #1a1f56;
		  letter-spacing: 1.5px;
		  text-align: left;
		}
		.timeline__event__content {
		  padding: 15px;
          width: 100%;
		}
		.timeline__event__date {
		  color: #c1b598;
		  font-size: 1rem;
		  font-weight: 400;
		  white-space: nowrap;
		}
		.timeline__event__icon {
		  font-family: "Poppins", sans-serif;
		  border-radius: 8px 0 0 8px;
		  background: #1a1f56;
		  display: flex;
		  align-items: center;
		  justify-content: center;
		  flex-basis: 20%;
		  font-size: 1rem;
		  color: #c1b598;
		  padding: 20px;
		}
		.timeline__event__icon i {
		  position: absolute;
		  top: 50%;
		  left: -67px;
		  font-size: 0.75rem;
		  transform: translateY(-50%);
		  font-family: "Poppins", sans-serif;
		}
		.timeline__event__description {
		  flex-basis: 60%;
		  font-size: 12px;
		}
		.timeline__event::after {
		  content: "";
		  width: 3px;
		  height: 100%;
		  background: #1a1f56;
		  position: absolute;
		  top: 52%;
		  left: -3.5rem;
		  z-index: -1;
		}
		.timeline__event::before {
		  content: "";
		  width: 5rem;
		  height: 5rem;
		  position: absolute;
		  background: #1a1f56;
		  border-radius: 100%;
		  left: -6rem;
		  top: 50%;
		  transform: translateY(-50%);
		}

		.timeline__event:last-child:after {
		  content: none;
		}

		@media (max-width: 786px) {
		  .timeline__event {
			flex-direction: column;
		  }

		  .timeline__event__icon {
			border-radius: 4px 4px 0 0;
		  }
		}
	
		/* Table Styles */

		.table-wrapper{
			margin: 0px;
            width: 100%;
		}

		.dd-table {
			font-size: 14px;
			font-weight: normal;
			border: none;
			border-collapse: collapse;
			width: 100%;
			max-width: 100%;
			white-space: nowrap;
			margin-right: 30px;

            th {
                
            background-color: white !important;
            }
		}

		.fl-table td, .fl-table th {
			text-align: left;
		}

		/* Responsive */

		@media (max-width: 767px) {
			.fl-table {
				display: block;
				width: 100%;
			}
			.fl-table thead, .fl-table tbody, .fl-table thead th {
				display: block;
			}
			.fl-table thead {
				float: left;
			}
			.fl-table tbody {
				width: auto;
				position: relative;
				overflow-x: auto;
			}
			.fl-table td, .fl-table th {
				padding: 20px .625em .625em .625em;
				height: 60px;
				vertical-align: middle;
				box-sizing: border-box;
				overflow-x: hidden;
				overflow-y: auto;
				width: 120px;
				font-size: 13px;
				text-overflow: ellipsis;
			}
			.fl-table thead th {
				text-align: left;
				border-bottom: 0px solid #f7f7f9;
			}
			.fl-table tbody tr {
				display: table-cell;
			}
			.fl-table tbody td {
				display: block;
				text-align: left;
			}
		}

</style>
